import { AddIcon, CrossIcon, DeleteCrossIcon } from '../../../../../../../../assets/icons/controls/controls';
import { TYPE_MAP } from '../../utils/editMainPageConstants';
function MobileBlocksList({
    layout,
    typeIndexByClientId,
    selectedBlockId,
    onOpenForm,
    onMoveBlock,
    onOpenBlockPicker,
    onDeleteBlock,
    renderPreview,
    getBlockTitle,
    isEditableType,
    canEditStructure,
}) {
    return (
        <div className='edit-main-page__list'>
            {layout.map((item, index) => {
                const type = item.block?.type || item.block;
                const canEdit = isEditableType(type);
                const typeIndex = typeIndexByClientId.get(item.clientId) || 1;
                const titleSuffix = typeIndex > 1 ? ` · ${typeIndex}` : '';
                const baseTitle = item.block?.title || TYPE_MAP[type]?.title || getBlockTitle(type);
                const title = `${baseTitle}${titleSuffix}`;
                const isSelected = selectedBlockId === item.clientId;

                return (
                    <div
                        className='edit-main-page__item'
                        key={item.clientId}
                        onClick={(event) => {
                            if (!canEdit) return;
                            const tag = event.target.tagName;
                            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'BUTTON') return;
                            onOpenForm(item.clientId);
                        }}
                    >
                        <div className='edit-main-page__item-header'>
                            <div className='edit-main-page__item-badge'>{index + 1}</div>
                            <div className='edit-main-page__item-meta'>
                                <p className='edit-main-page__item-title'>{title}</p>
                            </div>
                            <div className='edit-main-page__item-controls'>
                                {canEditStructure && <button
                                    className='edit-main-page__item-control edit-main-page__item-control_text'
                                    type='button'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onMoveBlock(index, 'up');
                                    }}
                                    disabled={!canEditStructure || index === 0}
                                >
                                    <span className='edit-main-page__item-control-text'>Вверх</span>
                                </button>}
                                {canEditStructure && <button
                                    className='edit-main-page__item-control edit-main-page__item-control_text'
                                    type='button'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onMoveBlock(index, 'down');
                                    }}
                                    disabled={!canEditStructure || index === layout.length - 1}
                                >
                                    <span className='edit-main-page__item-control-text'>Вниз</span>
                                </button>}
                                {canEditStructure && <button
                                    className='edit-main-page__item-control edit-main-page__item-control_text'
                                    type='button'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onOpenBlockPicker({ mode: 'replace', targetId: item.clientId });
                                    }}
                                    disabled={!canEditStructure}
                                >
                                    <span className='edit-main-page__item-control-text'>Тип</span>
                                </button>}
                                {canEditStructure && <button
                                    className='edit-main-page__item-control'
                                    type='button'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onDeleteBlock(index, title);
                                    }}
                                    disabled={!canEditStructure}
                                >
                                    <CrossIcon
                                        mainClassName={'edit-main-page__item-control-icon'}
                                        strokeClassName={'edit-main-page__item-control-icon-stroke'}
                                    />
                                </button>}
                                {canEdit ?
                                    <button
                                        className='edit-main-page__item-toggle'
                                        type='button'
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            onOpenForm(item.clientId);
                                        }}
                                    >
                                        Редактировать
                                    </button>
                                    : null}
                            </div>
                        </div>
                        <div className='edit-main-page__item-preview'>
                            {renderPreview(item, title, isSelected)}
                        </div>
                    </div>
                );
            })}
            {canEditStructure ?
                <button
                    className='edit-main-page__empty-add'
                    type='button'
                    onClick={() => onOpenBlockPicker({ mode: 'add', insertIndex: layout.length })}
                >
                    <AddIcon
                        mainClassName={'edit-main-page__empty-add-icon'}
                        fillClassName={'edit-main-page__empty-add-icon-fill'}
                    />
                    Добавить блок
                </button>
                : null}
        </div>
    );
}

export default MobileBlocksList;
